// Functionality: This file exports the FilterContainerGroup component which is used throughout the application for the sidebar and content container.

export default function FilterContainerGroup({
  filterContent,
  containerContent,
}) {
  return (
    <>
      <div className="filter-container-group-page">
        <div className="filter-container-group-sidebar">{filterContent}</div>
        <div className="filter-container-group-content-container">
          {containerContent}
        </div>
      </div>
    </>
  );
}
